import * as React from "react";

function SvgIconionicIosClose(props) {
  return (
    <svg width={14.004} height={14} {...props}>
      <path
        data-name="Icon ionic-ios-close"
        d="M8.661 7l5-5A1.172 1.172 0 0012.005.341l-5 5-5-5A1.172 1.172 0 10.348 1.998l5 5-5 5a1.172 1.172 0 101.657 1.657l5-5 5 5a1.172 1.172 0 101.657-1.657z"
        fill="#ee3b24"
      />
    </svg>
  );
}

export default SvgIconionicIosClose;
